import PropTypes from 'prop-types';
import React from 'react';

import CardListContainer from '../../components/cards/CardListContainer';
import ComposableCardList from './ComposableCardList';
import ComposableSlider from './ComposableSlider';
import VIEW_TYPES from './enum/cardListViewTypes';
import getComponentByType from './getComponentByType';

/**
 * Determines which card list container is being rendered and it's related cards
 * @param viewType determines how the container of the cards should look (e.g. Slider or CardList)
 * @param contentType determines the type of content of cards (e.g. articles, videos, static page)
 * @param variables the variables needed to query the correct cards
 * @returns ComposableCardList or ComposableSlider
 */
const ComposableCardListContainer = (props) => {
  const { viewType, contentType, variables } = props;

  return (
    <CardListContainer contentType={contentType} variables={variables}>
      {viewType === VIEW_TYPES.slider ? (
        <ComposableSlider
          {...props}
          renderCard={getComponentByType(contentType, viewType)}
        />
      ) : (
        <ComposableCardList {...props} />
      )}
    </CardListContainer>
  );
};

ComposableCardListContainer.defaultProps = {
  viewType: VIEW_TYPES.default,
  variables: {},
  isBrand: false,
};

ComposableCardListContainer.propTypes = {
  viewType: PropTypes.string,
  isBrand: PropTypes.bool,
  contentType: PropTypes.string.isRequired,
  variables: PropTypes.shape({
    limit: PropTypes.number,
    label: PropTypes.string,
  }),
};

export default ComposableCardListContainer;
